import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import {
  DRIVER_APP_NAME,
  DRIVER_ROUTES,
  DRIVER_SUPPORT,
} from '../data/driverAppSupport';
import '../styles/DriverLegal.css';

const HELP_TOPICS = [
  'Unable to login',
  'OTP / login problems',
  'Cannot see assigned trip',
  'Start Trip issue',
  'Odometer photo upload issue',
  'End Trip issue',
  'Customer collection entry issue',
  'App not loading',
  'App update issue',
  'Other technical problems',
];

const DriverSupport = () => {
  const whatsappHref = `https://wa.me/${DRIVER_SUPPORT.whatsappNumber}?text=${encodeURIComponent(
    `Hello EasyDropTaxi, I need help with the ${DRIVER_APP_NAME} App.`,
  )}`;

  return (
    <main className="driver-legal-page">
      <SeoHead
        title="EasyDropTaxi Driver App Support"
        description="Support page for authorized EasyDropTaxi Driver App users, including common help topics and EasyDropTaxi contact details."
        path={DRIVER_ROUTES.support}
      />

      <section className="page-banner block-space text-white" style={{ backgroundColor: 'var(--secondary-color)' }}>
        <div className="container">
          <h1 className="display-4 fw-bold">EasyDropTaxi Driver Support</h1>
          <p className="lead mb-0">For authorized EasyDropTaxi drivers.</p>
        </div>
      </section>

      <section className="block-space">
        <div className="container">
          <div className="driver-legal-content">
            <h2>App Information</h2>
            <div className="driver-contact-panel">
              <p className="mb-0">
                <strong>App Name:</strong> {DRIVER_APP_NAME}
              </p>
            </div>

            <h2>Common Help Topics</h2>
            <ul className="driver-support-topics">
              {HELP_TOPICS.map((topic) => (
                <li key={topic}>
                  <i className="fa fa-check-circle" aria-hidden="true"></i>
                  <span>{topic}</span>
                </li>
              ))}
            </ul>

            <h2>Contact Support</h2>
            <p>
              If you need help with the {DRIVER_APP_NAME} App, contact EasyDropTaxi using the
              support details below.
            </p>
            <div className="driver-contact-panel">
              <p>
                <strong>Phone:</strong>{' '}
                <a href={DRIVER_SUPPORT.phoneTel}>{DRIVER_SUPPORT.phoneDisplay}</a>
              </p>
              <p>
                <strong>Email:</strong>{' '}
                <a href={DRIVER_SUPPORT.mailto}>{DRIVER_SUPPORT.email}</a>
              </p>
              <p>
                <strong>WhatsApp:</strong>{' '}
                <a href={whatsappHref} target="_blank" rel="noopener noreferrer">
                  Message EasyDropTaxi
                </a>
              </p>
              <p className="mb-0">
                <strong>Office:</strong> {DRIVER_SUPPORT.address}
              </p>
            </div>

            <div className="driver-legal-actions">
              <a href={DRIVER_SUPPORT.phoneTel} className="btn driver-btn-primary">
                Call Support
              </a>
              <a
                href={whatsappHref}
                className="btn driver-btn-outline"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp Support
              </a>
            </div>

            <h2>Related Driver App Pages</h2>
            <ul>
              <li>
                <Link to={DRIVER_ROUTES.privacy}>Driver Privacy Policy</Link>
              </li>
              <li>
                <Link to={DRIVER_ROUTES.terms}>Driver Terms &amp; Conditions</Link>
              </li>
              <li>
                <Link to={DRIVER_ROUTES.dataDeletion}>Account &amp; Data Deletion</Link>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
};

export default DriverSupport;
